import { AUTHENTICATION_CONTEXT_REQUIREMENT_REF_PREFIX } from './requirementRef.util'

// "authContext:<name>" is this domain's own sentinel prefix — distinct from the group, named
// location, application, and user requirement prefixes — so a raw policyBody value is
// unambiguous about which kind of requirement it diverts to, without needing to know which field
// it came from.
export const REQUIREMENT_REF_PREFIX = AUTHENTICATION_CONTEXT_REQUIREMENT_REF_PREFIX

export const isRequirementRef = (value) => typeof value === 'string' && value.startsWith(REQUIREMENT_REF_PREFIX)

export const getRequirementId = (value) => (isRequirementRef(value) ? value.slice(REQUIREMENT_REF_PREFIX.length) : null)

export const toRequirementRef = (requirementId) => `${REQUIREMENT_REF_PREFIX}${requirementId}`

// Mirrors backend/src/lambdas/service/hub/microsoft/authenticationContextRequirements/
// resolveAuthenticationContextRequirements.js's RESOLUTION_STATUS. No CREATABLE status exists —
// creating an authentication context in the target tenant is out of scope, so a name that finds
// no single match is unresolvable.
export const AUTHENTICATION_CONTEXT_REQUIREMENT_STATUS = {
  MATCHED: 'matched',
  UNRESOLVABLE: 'unresolvable',
  LOOKUP_FAILED: 'lookupFailed',
}
